module.exports = __webpack_public_path__ + "static/manipulation-5dca0e6ae81813519cd89ba6e1866770.mp4";